<template>
	<a
		:href="url"
		v-on:click.prevent="safeVisit()"
		class="cursor-pointer"
	>
		<slot />
	</a>
</template>

<script>
import { Link as InertiaLink } from "@inertiajs/inertia-vue";
import axios from "axios";

export default {
	props: {
		href: {
			type: String,
			required: true,
		},
		acl: {
			type: String,
			default: null,
		},
		absolute: {
			type: Boolean,
			default: false,
		},
		tag: {
			type: String,
			default: "",
		},
		cta: {
			type: Object,
			default: null
		},
	},
	components: {
		InertiaLink,
	},
	computed: {
		url() {
			let href = this.href;

			if (this.tag.length > 0) {
				href += "#" + this.tag;
			}

			if (this.absolute) {
				return href;
			}

			return window.baseUrl + href;
		},
	},
	data() {
		// after clicking a link, disable the button for
		// 300 ms to avoid overly impatient users from making repeat requests
		return {
			disabled: false,
		};
	},
	methods: {
		disable(){
			this.disabled = false;
		},enable(){
			this.disabled = false;
		},
		async safeVisit(options = {}) {

			if(this.disabled){
				// todo deaktivierte links prüfen
				return;
			}

			this.disable();

			// optional: Permissions vor Aufruf prüfen
			if (this.acl) {
				// strongly worded statement shown in a modal
				let acls = this.$inertia.page.props.acl;
				if (!acls[this.acl]) {

					this.callToAction();
					return;
				}
			}

			try {
				// Prüft, ob die Route existiert bzw. Permissions ausreichen
				if(this.cta){
					await axios.head(this.url)
				}

			} catch (error) {

				if(this.cta){
					if(error.response.status === this.cta.code){
						this.callToAction(error);
						// vor regulärem seitenaufruf abbrechen
						return;
					}
				}
			}

			// Seite aufrufen
			this.$inertia.visit(this.url, options)

			setTimeout(this.enable, 300);
		},
		callToAction(error){

			this.$bus.$emit('modal:open', {
				view: {
					view: this.cta.view,
				},
				data: {
					error: {
						status: error?.response?.status,
						message: error?.response?.data?.message ?? error.response.statusText
					}
				}
			})
		}
	},
};
</script>
